<template>
  <div class="title-content">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "xxxx",
    },
  },
};
</script>

<style scoped lang="scss">
.title-content {
  color: green;
  font-size: 18px;
  background: #eee;
  text-align: center;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
}
</style>